
const NavImage = () => {
  return (
    <>
    <img src={`home/images/logo_tara.png?${new Date().getTime()}`} className="nvg_logo" />
    </>
  );
};

export default NavImage;
